import {
  CurrentPresenceOwnersEntryDateSortEnum,
  CurrentPresenceOwnersNameSortEnum,
  CurrentPresenceOwnersRegistrationNumberSortEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';
import { OrganizationsTreeSelect } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect';

export const CurrentPresenceOwnersTableHeader = () => {
  const { formatMessage } = useLocale();
  const {
    storedQueries: { [QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS]: ownersQuery },
    setQuery,
  } = useLocaleStoreQuery();

  return (
    <>
      <Table.HeaderItem>
        {formatMessage({ id: AppMessages['events.currentPresenceOwners.header.zone'] })}
      </Table.HeaderItem>

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS}
        sortBy={CurrentPresenceOwnersEntryDateSortEnum}
        queryHeader={formatMessage({ id: AppMessages['events.currentPresenceOwners.header.entry'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS}
        sortBy={CurrentPresenceOwnersNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['events.currentPresenceOwners.header.fullName'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS}
        sortBy={CurrentPresenceOwnersRegistrationNumberSortEnum}
        queryHeader={formatMessage({ id: AppMessages['events.currentPresenceOwners.header.registrationNumber'] })}
      />

      {/* Presence ignores data-access restrictions (contract R8), so the filter offers the full komórka tree. */}
      <OrganizationsTreeSelect
        multiple
        isFilterType
        useFilteredData={false}
        onChange={(options) =>
          options &&
          setQuery(QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS, {
            ...ownersQuery,
            komorka: options.map((cell) => cell.id),
          })
        }
        value={ownersQuery?.komorka?.map((id) => ({ id, nazwa: 'komorka' }))}
        placeholder={formatMessage({ id: AppMessages['events.currentPresenceOwners.header.cell'] })}
      />
    </>
  );
};
